import React, { createContext, useContext, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";

const TelemedicinaContext = createContext(null);

export function TelemedicinaProvider({ children }) {
  const [isWindowOpen, setIsWindowOpen] = useState(false);
  const [salaId, setSalaId] = useState(null);
  const [callLink, setCallLink] = useState(null);
  const [sessaoId, setSessaoId] = useState(null);
  const [paciente, setPaciente] = useState(null);
  const [appointment, setAppointment] = useState(null);

  const openWindow = useCallback(
    (data) => {
      setSalaId(data.salaId);
      setCallLink(data.callLink);
      setSessaoId(data.sessaoId);
      setPaciente(data.paciente || null);
      setAppointment(data.appointment || null);
      setIsWindowOpen(true);
    },
    []
  );

  const closeWindow = useCallback(() => {
    setIsWindowOpen(false);
    setSalaId(null);
    setCallLink(null);
    setSessaoId(null);
    setPaciente(null);
    setAppointment(null);
  }, []);

  const value = {
    isWindowOpen,
    salaId,
    callLink,
    sessaoId,
    paciente,
    appointment,
    openWindow,
    closeWindow,
  };

  return (
    <TelemedicinaContext.Provider value={value}>
      {children}
    </TelemedicinaContext.Provider>
  );
}

export function useTelemedicina() {
  const ctx = useContext(TelemedicinaContext);
  if (!ctx) {
    throw new Error("useTelemedicina deve ser usado dentro de TelemedicinaProvider");
  }
  return ctx;
}

/** Bloqueia navegação SPA enquanto a janela de telemedicina estiver aberta. */
export function useSafeNavigate() {
  const navigate = useNavigate();
  const toast = useToast();
  const { isWindowOpen } = useTelemedicina();
  return useCallback(
    (to, options) => {
      if (isWindowOpen) {
        toast({
          title: "Teleatendimento em andamento",
          description:
            "Finalize a chamada na janela de telemedicina antes de sair desta tela.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      navigate(to, options);
    },
    [navigate, isWindowOpen, toast]
  );
}
